
export default function CTA() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="cta" className="relative py-32 px-6 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/4b1b51fb45216d646faf1403e6541c07.jpg" 
          alt="Event anfragen" 
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/70 to-black/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white mb-6 tracking-tight leading-tight">
          Bereit für ein unvergessliches<br />kulinarisches Erlebnis?
        </h2>
        <p className="text-lg md:text-xl text-gray-200 font-light max-w-2xl mx-auto mb-12 leading-relaxed">
          Kontaktieren Sie uns jetzt und lassen Sie uns gemeinsam Ihr perfektes Event planen
        </p>
        <button 
          onClick={() => scrollToSection('kontakt')}
          className="px-12 py-4 bg-amber-600 text-white text-base font-light tracking-wide hover:bg-amber-700 transition-all duration-300 rounded-md cursor-pointer whitespace-nowrap shadow-2xl hover:shadow-amber-600/50 hover:scale-105"
        >
          Jetzt Event anfragen
        </button>
      </div>
    </section>
  );
}
